import { FechaFunctionsService } from '@/utils/functions.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExcelService } from '@services/excel.service';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-informes',
  templateUrl: './informes.component.html',
  styleUrls: ['./informes.component.scss']
})
export class InformesComponent {
  InformeVentaForm: FormGroup;
  InformeClienteForm: FormGroup;
  InformeArqueo: FormGroup;
  clientes: Array<any>;
  listaProductos: Array<any> = [];
  listaMetodoPago: Array<any> = [];
  dateSelected: any;
  year: any;
  month: any;

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    public generalService: GeneralService,
    public Func: FechaFunctionsService,
    private excelService: ExcelService,
    public loadingService: LoadingService) {
  }

  async ngOnInit() {
    this.year = this.Func.Today().getFullYear();
    this.month = this.Func.Today().getMonth() + 1;
    await this.getClientes();
    this.initializeForm();
  }

  initializeForm() {
    this.InformeVentaForm = this.fb.group({
      year: [this.year, Validators.required],
      month: [this.month, Validators.required],
    });
    this.InformeClienteForm = this.fb.group({
      id_cliente: [null, Validators.required],
      nombre_cliente: [null, Validators.required],
    });
    this.InformeArqueo = this.fb.group({
      year: [this.year, Validators.required],
      month: [this.month, Validators.required],
    });
  }

  onSelectItemCliente(item) {
    if (item == null) {
      this.InformeClienteForm.get('id_cliente').setValue(null);
      return
    }
    this.InformeClienteForm.get('id_cliente').setValue(item.id_cliente);
  }

  async getClientes() {
    try {
      this.loadingService.setLoading(true)
      let res = await this.generalService.getListar("cliente")
      this.clientes = res.data;
      this.loadingService.setLoading(false)
    } catch (error) {
      this.clientes = null
      this.loadingService.setLoading(false)
    }
  }

  async descargaInformeVenta(form) {
    try {
      this.loadingService.setLoading(true)
      let firstDay = new Date(form.year, form.month - 1, 1);
      let lastDay = new Date(form.year, form.month, 0)
      let queryParam: string = "?";
      queryParam = queryParam + `fecha_ingreso_to=${this.Func.DateFormated(firstDay)}&`;
      queryParam = queryParam + `fecha_ingreso_from=${this.Func.DateFormated(lastDay)}&`;
      let res = await this.generalService.getListar(`pedido/todo${queryParam}`)
      if (res.data.length > 0) {
        this.excelService.downloadInforme(res.data, `InformeVentas_${form.year}_${form.month}.xlsx`)
      }
      else {
        this.toastr.error("El mes seleccionado no tiene datos")
      }
      this.loadingService.setLoading(false)
    } catch (error) {
      console.log("🚀 ~ InformesComponent ~ descargaInformeVenta ~ error:", error)
      this.toastr.error("Error al generar informe")
      this.loadingService.setLoading(false)
    }
  }

  async descargaInformeCliente(form) {
    try {
      this.loadingService.setLoading(true)
      let res = await this.generalService.getObtiene(`pedido/cliente`, form.id_cliente)
      this.excelService.downloadInforme(res.data, `InformeCliente_${form.nombre_cliente.replace(/ /g, '_')}.xlsx`)
      this.loadingService.setLoading(false)
    } catch (error) {
      this.toastr.error("Error al generar informe")
      this.loadingService.setLoading(false)
    }
  }

  async descargaListadoProductos() {
    try {
      this.loadingService.setLoading(true)
      let res = await this.generalService.getListar("producto/all")
      this.excelService.downloadProductos(res.data)
      this.loadingService.setLoading(false)
    } catch (error) {
      this.toastr.error("Error al generar informe")
      this.loadingService.setLoading(false)
    }
  }

  async descargaInformeArqueo(form) {
    try {
      this.loadingService.setLoading(true)
      let firstDay = this.Func.DateFormated(new Date(form.year, form.month - 1, 1));
      let lastDay = this.Func.DateFormated(new Date(form.year, form.month, 0));
      let queryParam: string = "?";
      queryParam = queryParam + `fecha_pago_to=${this.Func.DateFormatedBD_toString(firstDay)}&`;
      queryParam = queryParam + `fecha_pago_from=${this.Func.DateFormatedBD_toString(lastDay)}&`;
      let res = await this.generalService.getListar(`arqueo/listado/mensual${queryParam}`)
      if (res.data.length > 0) {
        this.excelService.downloadInformeArqueo(res.data, `InformeArqueo_${form.year}_${form.month}.xlsx`)
      }
      else {
        this.toastr.error("El mes seleccionado no tiene datos")
      }
      this.loadingService.setLoading(false)
    } catch (error) {
      console.log("🚀 ~ InformesComponent ~ descargaInformeVenta ~ error:", error)
      this.toastr.error("Error al generar informe")
      this.loadingService.setLoading(false)
    }
  }
}
